module.exports = __webpack_public_path__ + "img/grafik-penyumbang-erk.3f60cdb7.png";